import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import extend from 'quasar/src/utils/extend.js';
import user from '@/store/user';
import {URL_API} from '@/config';
import {getModule} from 'vuex-module-decorators';
import {TUser} from '@/types/TUser';
import {TUserForAdmin} from '@/types/TUserForAdmin';
import {ServiceAdminUsers} from '@/services/ServiceAdminUsers';
import {CONFIG_ENV} from '@/config';
import UserProfile from '@/components/Admin/UserProfile/UserProfile.vue'
import EditNewUser from '@/components/Admin/EditNewUser/EditNewUser.vue'


@Component({components: {UserProfile, EditNewUser}})
export default class Users extends Vue {
    @Prop({ default: '0' }) public readonly userid!: string;
    public users:TUserForAdmin[] = [];
    public loadingData = true;
    public isAdminUsersActivated=false;
    public dialogUser = false;
    public dialogTransitionShow ='';
    public dialogTransitionHide ='';
    public urlUserImgProfileByAppid = CONFIG_ENV.URL_ADMIN.users+'/img_user_profile_jpg_by_user_appid'
    public filter = '';
    public titleComponent='';
    public $refs: any;
    public currentPage=1;
    public dynamicComponent='';
    public totalNumberOfPages=1;
    public selectedUser:TUserForAdmin={
        appid: '',
        userid: '',
        firstName: '',
        lastName: '',
        emailAddress: '',
        phoneNr: '',
        isDisabled: '',
        companyCode: '',
        companyName: '',
        userToken: '',
        urlUserImgProfileByAppid:'',
        hasAvatar:''
    }
    public userStore = getModule(user);
    public myPagination:any={rowsPerPage:10}
    public visibleColumns: string[] = [ 'userid', 'firstName', 'lastName', 'phoneNr', 'emailAddress', 'isDisabled', 'Company'];
    public  columns: any = [
        { name: 'appid', label: '', field: 'appid', align: 'left',  classes: 'bg-grey-1'},
        { name: 'userid', label: 'User Id', field: 'userid', align: 'left', sortable: true, classes: 'bg-grey-1'},
        { name: 'firstName', label: 'First name', field: 'firstName', align: 'left', sortable: true  },
        { name: 'lastName', label: 'Last name', field: 'lastName', align: 'center', sortable: true },
        { name: 'phoneNr', label: 'Telefon', field: 'phoneNr', align: 'left', sortable: true },
        { name: 'emailAddress', label: 'Email', field: 'emailAddress', align: 'left', sortable: true },
        { name: 'isDisabled', label: 'User blocat', field: 'isDisabled', align: 'left', sortable: true },
        { name: 'Company', label: 'Company', field: 'companyCode', align: 'left', sortable: true },
    ];


    public get user(): TUser {
        return this.userStore.user;
    }

    public resetPassword(){
        ServiceAdminUsers.resetPassword('abc')
    }

    public openUserDetails(userappid:string){
        //this.selectedUser=puser
       // extend(true, this.selectedUser,  puser);
        this.titleComponent='Administrare utilizator';
        this.selectedUser.appid=userappid;
        this.dynamicComponent='UserProfile';
      if(this.$q.platform.is.mobile){
          this.dialogTransitionShow ='slide-left';
          this.dialogTransitionHide ='slide-right';
      }else{
          this.dialogTransitionShow ='slide-right';
          this.dialogTransitionHide ='slide-left';
      }
        this.dialogUser=true;
    }

    public openFormAddNewUser(){
        this.selectedUser.appid='0';
        this.titleComponent='Creare cont nou de utilizator';
        this.dynamicComponent='EditNewUser';
        if(this.$q.platform.is.mobile){
            this.dialogTransitionShow ='slide-left';
            this.dialogTransitionHide ='slide-right';
        }else{
            this.dialogTransitionShow ='slide-right';
            this.dialogTransitionHide ='slide-left';
        }
        this.dialogUser=true;
    }

    public fnOnSaveData(userappid:string){
        console.log('fnOnSaveData with userid=%o',userappid);
        //this.dialogUser=false;
        this.openUserDetails(userappid);
    }

    public getUsers(){
        const vueInst = this;
        vueInst.loadingData=true;
        vueInst.users=[];
        ServiceAdminUsers.getUsers().then(response=>{
            vueInst.loadingData=false;
            if(response.status=='success'){
                vueInst.users=response.users.map(user=> {return {
                    appid: user.appid,
                    userid: user.userid,
                    firstName: user.firstName,
                    lastName: user.lastName,
                    emailAddress: user.emailAddress,
                    phoneNr: user.phoneNr,
                    isDisabled: user.isDisabled,
                    companyCode: user.companyCode,
                    companyName: user.companyName,
                    userToken: user.userToken,
                    hasAvatar: user.hasAvatar,
                    urlUserImgProfileByAppid:vueInst.urlUserImgProfileByAppid+'/'+user.appid
                }});
            }
        })
    }

    public activated(){
        this.isAdminUsersActivated=true;
        this.userStore.set_page_transition('fade-in-right');
        if(this.$q.platform.is.mobile) {
            this.userStore.set_showbackbar(true);
            this.userStore.set_title_back_bar('Utilizatori');
        }
    }

    public created(): void {
        const vueInst = this;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        vueInst.$eventHub.$on('eventClickAddBtn', (params: any) => {
            if(vueInst.isAdminUsersActivated){
                vueInst.openFormAddNewUser();
            }
        })
        vueInst.getUsers();
    }

    public deactivated() {
        this.isAdminUsersActivated = false;
    }

    public beforeDestroy() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        this.$eventHub.$off('eventClickAddBtn');
    }

}
